import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textareaWrapperFn = /* @__PURE__ */ createRecipe('textarea-wrapper', {}, [])

const textareaWrapperVariantMap = {}

const textareaWrapperVariantKeys = Object.keys(textareaWrapperVariantMap)

export const textareaWrapper = /* @__PURE__ */ Object.assign(memo(textareaWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'textareaWrapper',
  __getCompoundVariantCss__: textareaWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textareaWrapperVariantKeys,
  variantMap: textareaWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textareaWrapperVariantKeys)
  },
  getVariantProps: textareaWrapperFn.getVariantProps,
})